export enum FilterPlaceHolderEnum {
    EmNumbersPlaceholderFilter = 'ÐÐ°Ð·Ð²Ð°Ð½Ð¸Ðµ Ð¸Ð»Ð¸ Ð½Ð¾Ð¼ÐµÑ ÑÐµÐ»ÐµÑÐ¾Ð½Ð°',
    AdsPlaceholderFilter = 'ÐÐ°Ð³Ð¾Ð»Ð¾Ð²Ð¾Ðº Ð¸Ð»Ð¸ ÑÐµÐºÑÑ Ð¾Ð±ÑÑÐ²Ð»ÐµÐ½Ð¸Ñ',
    OverviewPlaceholderFilter = 'ÐÐ´ÑÐµÑ Ð¸Ð»Ð¸ ÐºÐ°Ð´Ð°ÑÑÑÐ¾Ð²ÑÐ¹ Ð½Ð¾Ð¼ÐµÑ',
  }
  